import BaseModelAPI from '../BaseModelAPI';

export default class StockOpnameResultList extends BaseModelAPI {

	static entity = 'stockopnameresultlist'
	static entityName = 'stockopnameresult';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
